const radiogroup = {
    radio: {
        borderWidth: { value: '{components.radio.button.borderWidth}' },
        borderColor: { value: '{components.radio.button.borderColor}' },
        backgroundColor: { value: '{components.radio.button.backgroundColor}' },
        _checked: {
            color: { value: '{components.radio.button._checked.color}' },
        },
        label: {
            color: { value: '{components.radio.label.color}' },
        },
    },
    legend: {
        color: { value: '{components.fieldset.legend.color}' },
        fontWeight: { value: '{fontWeights.normal}' },
    },
};

export { radiogroup };
